"use strict";
Object.defineProperty(exports, "__esModule", { value: true });



//////////////////
// WEBPACK FOOTER
// ./~/@ctrl/tinycolor/dist/interfaces.js
// module id = 244
// module chunks = 0